import { Component, Prop, h } from "@stencil/core";

@Component({
  tag: "bcp-activity-indicator",
  styleUrl: "bcp-activity-indicator.scss",
})
export class BcpActivityIndicator {
  @Prop() isInline = false;
  @Prop() isAbsolute: boolean;
  @Prop() theme?: string = document.body.dataset.theme;
  @Prop() size: "small" | "medium" | "large"; // TTRQ-37260 custom  - adjust loader to brand

  render() {
    switch (this.theme) {
      case "buderus":
        return (
          <div class="rotating-activity-indicator-container">
            <div class="rotating-activity-indicator-plane">
              <svg class="buderus-activity-indicator-icon" viewBox="0 0 40 40">
                <rect
                  class="buderus-activity-indicator-icon-background-color"
                  width="40"
                  height="40"
                />
                <rect
                  class="buderus-activity-indicator-icon-color"
                  x="8.75"
                  y="32.875"
                  width="22.5"
                  height="1.624999"
                />
                <path
                  class="buderus-activity-indicator-icon-color"
                  d="M26.875,15.5c2.75-0.5,4.5-2.375,4.25-5C31,8.625,30,5.4999995,21.9999981,5.4999995H8.75v21.25h15
                      c5.875,0.125,8.375-3,8.375-6.0000019C32.25,18.125,30.125,15.875,26.875,15.5z M15.125,9.625h6.125
                      c2.75,0,3.375,0.75,3.375,1.875c0,1.25-0.625,2.374999-3.375,2.374999h-6.125V9.625z M20.125,22.75H15v-5h6.625
                      c2.3749981,0,3.375,0.875,3.375,2.6250019C25,22,24,22.75,20.125,22.75z"
                />
              </svg>
            </div>
          </div>
        );
      case "vulcano":
        return (
          <div class="rotating-activity-indicator-container">
            <div class="rotating-activity-indicator-plane">
              <svg x="0px" y="0px" viewBox="0 0 40 40">
                <g>
                  <path
                    class="vulcano-activity-indicator-icon-color"
                    d="M19.67,40L5.21,12.92h7.75c3.18-8.46,0.26-11.06-2.21-12.72c-0.17-0.1-0.09-0.25,0.11-0.19 c20.87,6.4-8.48,23.35,13.32,31.89L19.67,40z"
                  />
                  <path
                    class="vulcano-activity-indicator-icon-color"
                    d="M18.62,2.87c13.95,6.89-5.73,20.97,5.64,28.88l10.52-18.83l-7.39,0c1.31-7.1-5.7-9.61-8.68-10.27 C18.47,2.61,18.41,2.72,18.62,2.87"
                  />
                </g>
              </svg>
            </div>
          </div>
        );
      default:
        return (
          // TTRQ-37260 custom start - adjust loader to brand
          <div class="a-activity-indicator__background">
            <div class={`a-activity-indicator -${this.size}`}>
              <div class="a-activity-indicator__top-box"></div>
              <div class="a-activity-indicator__bottom-box"></div>
            </div>
            <span class="A-loaderIndicator__el A-loaderIndicator__el--0"></span>
            <span class="A-loaderIndicator__el A-loaderIndicator__el--1"></span>
            <span class="A-loaderIndicator__el A-loaderIndicator__el--2"></span>
            <span class="A-loaderIndicator__el A-loaderIndicator__el--3"></span>
            <span class="A-loaderIndicator__el A-loaderIndicator__el--4"></span>
            <span class="A-loaderIndicator__el A-loaderIndicator__el--5"></span>
            <span class="A-loaderIndicator__el A-loaderIndicator__el--6"></span>
            <span class="A-loaderIndicator__el A-loaderIndicator__el--7"></span>
            <span class="A-loaderIndicator__el A-loaderIndicator__el--8"></span>
            <span class="A-loaderIndicator__el A-loaderIndicator__el--9"></span>
            <span class="A-loaderIndicator__el A-loaderIndicator__el--10"></span>
            <span class="A-loaderIndicator__el A-loaderIndicator__el--11"></span>
          </div>
          // TTRQ-37260 custom end
        );
    }
  }
}

/*

          <div class="spinner-container">
            <div class="spinner-dark">
              <svg version="1.1" id="Ebene_1" class='spinner-svg' x="0px" y="0px"
              viewBox="0 0 40 40">
                <g id="Ebene_2_1_">
                  <rect class="st0" width="40" height="40"/>
                </g>
                <g id="Ebene_3">
                  <g>
                    <rect class="st0" width="40" height="40"/>
                    <rect x="8.75" y="32.875" class="st1" width="22.5" height="1.624999"/>
                    <path class="st1" d="M26.875,15.5c2.75-0.5,4.5-2.375,4.25-5C31,8.625,30,5.4999995,21.9999981,5.4999995H8.75v21.25h15
                                    c5.875,0.125,8.375-3,8.375-6.0000019C32.25,18.125,30.125,15.875,26.875,15.5z M15.125,9.625h6.125
                                    c2.75,0,3.375,0.75,3.375,1.875c0,1.25-0.625,2.374999-3.375,2.374999h-6.125V9.625z M20.125,22.75H15v-5h6.625
                                    c2.3749981,0,3.375,0.875,3.375,2.6250019C25,22,24,22.75,20.125,22.75z"/>
                  </g>
                </g>
              </svg>
            </div>
          </div>
          */
